import { handleActions } from 'redux-actions';
import RecurringPaymentsType from '../types/RecurringPaymentsType';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  recurringPayments: { ...initialStateList },
  bankCodes: [],
};
export const RecurringPayments = handleActions(
  {
    ...GridFilters,
    [RecurringPaymentsType.actions.fetchRecurrntPaymentsDetailsSuccess]: (state) => {
      return {
        ...state,
      };
    },
  },
  initialState
);

const getRecurringPayments = (state) => state.RecurringPayments;

export const getRecurringPaymentsList = (state, list) => {
  const recurringPayments = getRecurringPayments(state);
  return recurringPayments[list] || undefined;
};
